import React from 'react';
import './Compositions.css';

import { compositions } from '../../../constants';
import { Heading } from '../../../components';



const WaterComposition = () => {

  const { sub, heading, items, image } = compositions;

  // Split items into two groups for left and right boxes
  const leftItems = items.slice(0, 3);
  const rightItems = items.slice(3);

  return (
    <section className="water-composition">

      {/* Section Heading */}
      <Heading title={heading} subTitle={sub} linear />

      <div className="box-container">

        <div className="box-1">
          {leftItems.map((item, index) => (
            <div className="water-item" key={index}>
              <h3><span>{item.symbol}</span>{item.name}</h3>
              <h5>{item.value}</h5>
              <p>{item.description}</p>
            </div>
          ))}
        </div>

        <div className="image">
          <img src={image.src} alt={image.alt} />
        </div>

        <div className="box-2">
          {rightItems.map((item, index) => (
            <div className="water-item" key={index}>
              <h3>{item.name} <span>{item.symbol}</span></h3>
              <h5>{item.value}</h5>
              <p>{item.description}</p>
            </div>
          ))}
        </div>

      </div>

    </section>
  );
};

export default WaterComposition;